import React from 'react';

import { FilterIcon } from '@vlabs/icons';
import { useEventListFilters } from '@vlabs/monokit/entities/events/filters';
import { Badge } from '@vlabs/uikit';
import { Button } from '@vlabs/uikit/components/controls/button';
import { useTranslation } from 'react-i18next';

import st from './Settings.module.sass';
import { countAppliedWorkspaceFilters } from '../filters/countAppliedFilters';

export const EVENT_ROLL_SIDEBARS = {
  FILTERS: 'filters',
} as const;

export type SidebarName = typeof EVENT_ROLL_SIDEBARS[keyof typeof EVENT_ROLL_SIDEBARS];

interface SettingsProps {
  activeSidebar: SidebarName | null;
  onToggleSidebar: (name: SidebarName) => void;
}

export function Settings({
  activeSidebar,
  onToggleSidebar,
}: SettingsProps): React.JSX.Element {
  const { t } = useTranslation();
  const { filters } = useEventListFilters();

  const countActiveFilters = countAppliedWorkspaceFilters(filters);

  return (
    <div className={st.Root}>
      <div className={st.Root_Buttons}>
        <Button
          data-testid="workspace.openFilters"
          icon={<FilterIcon />}
          kind={activeSidebar === EVENT_ROLL_SIDEBARS.FILTERS ? 'secondary' : 'primary'}
          onClick={() => onToggleSidebar(EVENT_ROLL_SIDEBARS.FILTERS)}
          size="small"
          variant={activeSidebar === EVENT_ROLL_SIDEBARS.FILTERS ? 'filled' : 'outlined'}
        >
          {t('фильтры')}
          {(countActiveFilters > 0) && (
            <Badge
              className={st.FiltersQuantityBadge}
              kind="negative"
              shape="round"
              value={countActiveFilters}
            />
          )}
        </Button>
      </div>
    </div>
  );
}
